import React from 'react'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
const TopBarCalendar = ({schoolCalendar, setSchoolCalendar, createNewPendingOffer, createNewCalendarEvent, userData}) => {
    const [schools, setSchools] = React.useState([])
    const isManager = userData.PermissionLevel === 'manager' && userData.IsAdmin

    React.useEffect(() => {
        axios.get(`${baseUrl}/schools`)
        .then(res => {
          setSchools(res.data)
          isManager ? setSchoolCalendar(res.data.filter((e) => e.schoolAbbreviation === userData.School.toUpperCase())[0]) :
          setSchoolCalendar(res.data.filter((e) => e.schoolAbbreviation === 'MMA')[0])
        })
        .catch(err => console.log(err))
    }, [])

      const chooseTheSchool = (id) => {
        setSchoolCalendar(schools.filter(school => school.id === id)[0])
      }

    return(
        <div className='calendar__topbar'>
            <div className='calendar__topbar-left'>
              <div className='calendar__topbar-title'>Calendar</div>
              {schoolCalendar && !isManager &&
                <div className="calendar__topbar-school-select-wrap">
                  <select className="calendar__topbar-school-select" value={schoolCalendar.id} onChange={(e) => chooseTheSchool(e.target.value)}>
                    {schools.map((school) => (
                      <option key={school.id} value={school.id}>{school.name}</option>
                    ))}
                  </select>
                </div>
              }
            </div>
            <div className='calendar__topbar-actions'>
              {/* <button
                    type="button" onClick={() => createNewPendingOffer()} className="ml-6 cursor-pointer float-right mt-4 rounded-3xl border border-transparent border-black bg-white py-2 px-4 text-sm font-medium text-black shadow-sm hover:bg-white hover:shadow-xl transition-shadow duration-300 focus:outline-none"
                  >
                    Add Offer +
                  </button> */}
              <button onClick={() => createNewCalendarEvent()} type="button" className="calendar__topbar-primary-btn">
                New Event +
              </button>
            </div>
        </div>
    )
}
export default TopBarCalendar
